// base
import React, { Component } from "react";

// components
import { Button } from "..";
import {
  FiExternalLink,
  MdEmail,
  IoDocumentText,
  RiKakaoTalkFill,
  FaBlog,
  RiTwitterFill,
  RiTelegramFill,
  RiFacebookCircleFill,
  RiMediumFill,
} from "react-icons/all";

import { substring } from "../../../helper";

// assets
import "./ContractProfileSummary.scss";

class ContractProfileSummary extends Component {
  render() {
    const {
      address,
      decimals,
      official,
      mail,
      whitepaper,
      kakao,
      band,
      twitter,
      telegram,
      facebook,
      medium,
      memo,
      tokenType,
    } = this.props.contract;

    return (
      <div className="responsive_table contract_profile_summary">
        <table className="table_type03">
          <colgroup>
            <col width="200px" />
            <col />
          </colgroup>
          <tbody>
            <tr>
              <th>Contract:</th>
              <td>
                <Button color="gray" disable={true} tooltip={address}>
                  {substring(address, 10)}
                </Button>
              </td>
            </tr>
            {tokenType === "ARC20" && (
              <tr>
                <th>Decimals:</th>
                <td>{decimals}</td>
              </tr>
            )}

            <tr>
              <th>Official Site:</th>
              <td>
                {official && (
                  <a
                    href={official}
                    target={"_blank"}
                    className="official_link"
                  >
                    {official}
                    <FiExternalLink className="link_icon" />
                  </a>
                )}
              </td>
            </tr>
            <tr>
              <th>Social Profiles:</th>
              <td>
                {mail && (
                  <a
                    href={`mailto:${mail}`}
                    className="social_link"
                    data-tip={`Email: ${mail}`}
                  >
                    <MdEmail className="social_icon" />
                  </a>
                )}
                {whitepaper && (
                  <a
                    href={whitepaper}
                    className="social_link"
                    target={"_blank"}
                    data-tip={`Whitepaper: ${whitepaper}`}
                  >
                    <IoDocumentText className="social_icon" />
                  </a>
                )}
                {kakao && (
                  <a
                    href={kakao}
                    className="social_link"
                    target={"_blank"}
                    data-tip={`Kakao: ${kakao}`}
                  >
                    <RiKakaoTalkFill className="social_icon" />
                  </a>
                )}
                {band && (
                  <a
                    href={band}
                    className="social_link"
                    target={"_blank"}
                    data-tip={`Band: ${band}`}
                  >
                    <FaBlog className="social_icon" />
                  </a>
                )}
                {twitter && (
                  <a
                    href={twitter}
                    className="social_link"
                    target={"_blank"}
                    data-tip={`Twitter: ${twitter}`}
                  >
                    <RiTwitterFill className="social_icon" />
                  </a>
                )}
                {telegram && (
                  <a
                    href={telegram}
                    className="social_link"
                    target={"_blank"}
                    data-tip={`Telegram: ${telegram}`}
                  >
                    <RiTelegramFill className="social_icon" />
                  </a>
                )}
                {facebook && (
                  <a
                    href={facebook}
                    className="social_link"
                    target={"_blank"}
                    data-tip={`Facebook: ${facebook}`}
                  >
                    <RiFacebookCircleFill className="social_icon" />
                  </a>
                )}
                {medium && (
                  <a
                    href={medium}
                    className="social_link"
                    target={"_blank"}
                    data-tip={`Medium: ${medium}`}
                  >
                    <RiMediumFill className="social_icon" />
                  </a>
                )}
              </td>
            </tr>
            <tr>
              <th>Memo:</th>
              <td>{memo}</td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }
}

export default ContractProfileSummary;
